<template>
  <div>
    <span class="arrow" :class="{'active': popShow}"></span>
    <div class="preset">
      <div v-for="option in presets" @click="setActivePreset(option)" class="preset-option select-button" :class="activePreset == option ? 'select-button--active' : ''">{{ $t('common.tables.period_' + option)  }}</div>
    </div>
    <div class="wheel-range-inputs">
      <div>
        <input type="text" readonly="readonly" class="input-select"
               :class="activeInput == 'from' ? 'hover-input' : ''"
               v-model="selectNilai" @focus="showPanel" :placeholder="placeholder">
        <input type="hidden" readonly="readonly" class="inputClass" :style="inputStyle"
               :placeholder="placeholder"
               v-model="selectValue" @focus="showPanel"/>
      </div>

      <template v-if="range">
        <div style="padding: 10px">{{ $t('common.buttons.to') }}</div>
        <div>
          <input type="text" readonly="readonly" class="input-select"
                 :class="activeInput == 'to' ? 'hover-input' : ''"
                 v-model="selectNilai2" @focus="showPanel2" :placeholder="placeholder">
          <input type="hidden" readonly="readonly" :class="inputClass" :style="inputStyle"
                 :placeholder="placeholder"
                 v-model="selectValue2" @focus="showPanel2"/>
        </div>

      </template>
    </div>


    <div class="vue-date-select-container"
         @mousemove="handleTouch($event)"
         @mouseup="handleTouch($event)"
         @touchend="clearHover"
    >
      <div class="vm-dialog-content s" :style="{'margin-top': parseInt((windowHeight-260)*0.4)+'px'}">
        <div class="vm-wheels">
          <div class="vm-wheel" v-for="(item, wheelIndex) in wheels"
               @touchstart="handleTouch($event, wheelIndex)"
               @touchmove="handleTouch($event, wheelIndex)"
               @touchend="handleTouch($event, wheelIndex)"
               @mousedown="handleTouch($event, wheelIndex)"
               @mousewheel="handleTouch($event, wheelIndex)"
               @DOMMouseScroll="handleTouch($event, wheelIndex)">
            <div class="vm-line" :style="{borderColor:themeColor}"></div>
            <div class="vm-items-wrapper" :class="{'anim': item.anim}"
                 :style="{'transform':'translate3d(0,'+ item.translateY +'px, 0)', 'transition-duration': item.anim ? item.transitionTime : '0s' }">
              <div v-for="(optionItem, itemIndex) in item.data"
                   class="vm-option normal"
                   :class=" isActiveClass(wheelIndex) == itemIndex ? 'active-option' : ''"
                   @click="handleSingleClick($event, wheelIndex, itemIndex)"
                   @touchstart="hoverClass($event, wheelIndex, itemIndex)"
                   @mousedown="hoverClass($event, wheelIndex, itemIndex)">
                <span class="option-span" v-if="wheelIndex != 1">
                  {{ (optionItem < 10 ? '0' + optionItem : optionItem) }}
                </span>
                <span class="option-span" v-else>
                  {{ callBulan(wheelIndex, optionItem) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

  export default {
    name: "vuedatereward",
    props: {
      range: {
        type: Boolean,
        default: false,
      },
      value: {
        type: String,
        default: ''
      },
      valueFrom: {
        type: String,
        default: ''
      },
      valueTo: {
        type: String,
        default: ''
      },
      min: {
        type: String,
        default: ''
      },
      max: {
        type: String,
        default: ''
      },
      startPeriodPreset: {
        type: String,
        default: '1W'
      },
      presets: {
        type: Array,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      inputClass: {
        type: [String, Object, Array],
        default: ''
      },
      inputStyle: {
        type: [String, Object, Array],
        default: ''
      },
      themeColor: {
        type: String,
        default: '#03a9f4'
      }
    },
    data: function () {
      return {
        activePreset: '',
        timerId: null,
        activeInput: 'from',
        popShow: true,
        selectValue: '',
        selectValue2: '',
        selectNilai: '',
        selectNilai2: '',
        wheels: [
          {
            type: 'month',
            translateY: 0,
            anim: false,
            transitionTime: '700ms',
            data: []
          },
          {
            type: 'day',
            translateY: 0,
            anim: false,
            transitionTime: '700ms',
            data: []
          },
          {
            type: 'year',
            translateY: 0,
            anim: false,
            transitionTime: '700ms',
            data: []
          }
        ],
        startY: 0,
        moveY: 0,
        oldMoveY: 0,
        moveEndY: 0,
        offsetDistance: 0,
        offset: 0,
        oversizeBorder: 0,
        startTime: 0,
        liHeight: 40,
        minDate: '',
        maxDate: '',
        initDate: '',
        clickFlag: false,
        activeClick: {
          wheelIndex: -100,
          itemIndex: -100
        },
        activeWheelIndex: 0,
        windowHeight: 300
      }
    },
    computed: {
      hoverColor: function () {
        var hex = this.themeColor,
          opacity = 0.08,
          result = '';
        if (hex.replace(/\s+/g, '').length === 7) {
          result = 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' +
            parseInt('0x' + hex.slice(3, 5)) + ',' +
            parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')';
        } else {
          var rgb = hex.split('(')[1].split(')')[0].split(',');
          result = 'rgba(' + rgb[0].trim() + ',' + rgb[1].trim() + ',' + rgb[2].trim() + ',' + opacity + ')';
        }
        return result || '';
      },
    },
    mounted: function () {
      this.initSetting();
      this.initOption();
      this.initListener();
      this.initStartPositions();
    },
    unmounted() {
      clearTimeout(this.timerId);
    },
    methods: {
      isActiveClass(index) {
        let dataIndex = this.getIndexByDistance(this.wheels[index].translateY);
        return dataIndex
      },
      initStartPositions: function (){
        if(this.startPeriodPreset && !this.valueFrom){
          this.setActivePreset(this.startPeriodPreset)
        }else if(this.valueFrom){
          let from  = this.valueFrom && this.checkIsFormatStr(this.valueFrom) ? this.valueFrom : this.getDateStr(new Date());
          let to  = this.valueTo && this.checkIsFormatStr(this.valueTo) ? this.valueTo : this.getDateStr(new Date());

          this.locateWheelByVal(from);

          this.selectValue = from;
          this.selectNilai = from;

          this.selectValue2 = to;
          this.selectNilai2 = to;

          this.checkIsNamedPeriod()
          this.$emit('input', this.selectValue);
          this.$emit('input2', this.selectValue2);
        }
      },
      setActivePreset(option){
        this.activePreset = option
        let BeforeMaxStr
        if(option === '1W'){
          BeforeMaxStr = this.$dayjs(this.maxDate).subtract(1, 'week').format('YYYY-MM-DD')
        }
        if(option === '1M'){
          BeforeMaxStr = this.$dayjs(this.maxDate).subtract(1, 'month').format('YYYY-MM-DD')
        }
        if(option === '3M'){
          BeforeMaxStr = this.$dayjs(this.maxDate).subtract(3, 'month').format('YYYY-MM-DD')
        }
        if(option === '6M'){
          BeforeMaxStr = this.$dayjs(this.maxDate).subtract(6, 'month').format('YYYY-MM-DD')
        }
        if(option === '1Y'){
          BeforeMaxStr = this.$dayjs(this.maxDate).subtract(1, 'year').format('YYYY-MM-DD')
        }
        if(this.activeInput == 'from'){
          this.locateWheelByValObject(this.getDateStrObj(BeforeMaxStr))
        }
        if(this.activeInput == 'to'){
          this.locateWheelByValObject(this.getDateStrObj(this.maxDate))
        }

        this.selectValue = BeforeMaxStr;
        this.selectNilai = BeforeMaxStr;

        this.selectValue2 = this.maxDate;
        this.selectNilai2 = this.maxDate;

        this.$emit('input', this.selectValue);
        this.$emit('input2', this.selectValue2);
        this.$emit('namedPeriod', option);
      },
      checkIsNamedPeriod(){
        let status = null;
        if(this.selectValue2 == this.maxDate){
          let weekBeforeTo = this.$dayjs(this.maxDate).subtract(1, 'week').format('YYYY-MM-DD')
          let monthBeforeTo = this.$dayjs(this.maxDate).subtract(1, 'month').format('YYYY-MM-DD')
          let threeMonthBeforeTo = this.$dayjs(this.maxDate).subtract(3, 'month').format('YYYY-MM-DD')
          let sixMonthBeforeTo = this.$dayjs(this.maxDate).subtract(6, 'month').format('YYYY-MM-DD')
          let yearBeforeTo = this.$dayjs(this.maxDate).subtract(1, 'year').format('YYYY-MM-DD')

          switch(this.selectValue) {
            case weekBeforeTo:
              status = '1W'
              break;
            case monthBeforeTo:
              status = '1M'
              break;
            case threeMonthBeforeTo:
              status = '3M'
              break;
            case sixMonthBeforeTo:
              status = '6M'
              break;
            case yearBeforeTo:
              status = '1Y'
              break;
          }
        }

        this.activePreset = status
        this.$emit('namedPeriod', status);
      },
      initListener: function () {
        var _this = this;
        window.addEventListener("resize", function () {
          _this.windowHeight = 300;
        }, false);
      },
      initSetting: function () {
        this.initDate = this.value && this.checkIsFormatStr(this.value) ? this.value : this.getDateStr(new Date());
        this.maxDate = this.max && this.checkIsFormatStr(this.max) ? this.max : this.getDateStr(new Date(), 2);
        this.minDate = this.min && this.checkIsFormatStr(this.min) ? this.min : this.getDateStr(new Date(), -10);
      },
      initOption: function () {
        var maxDateObj = this.getDateStrObj(this.maxDate);
        var minDateObj = this.getDateStrObj(this.minDate);
        var initDateObj = this.getDateStrObj(this.initDate);

        for (var i = minDateObj.year; i <= maxDateObj.year; i++) {
          this.wheels[0].data.push(i);
        }
        for (var j = 1; j <= 12; j++) {
          this.wheels[1].data.push(j);
        }
        for (var k = 1; k <= this.calcDays(initDateObj.year, initDateObj.month); k++) {
          this.wheels[2].data.push(k);
        }
        this.locateWheelByVal(this.initDate);
      },
      locateWheelByVal: function (dateString) {
        var minDateObj = this.getDateStrObj(this.minDate);
        var dateObj = this.getDateStrObj(dateString);
        this.wheels[0].translateY = this.getDistanceByIndex(dateObj.year - minDateObj.year);
        this.wheels[1].translateY = this.getDistanceByIndex(dateObj.month - 1);
        this.wheels[2].translateY = this.getDistanceByIndex(dateObj.day - 1);
      },
      locateWheelByValObject: function (dateObj) {
        var minDateObj = this.getDateStrObj(this.minDate);
        this.wheels[0].translateY = this.getDistanceByIndex(dateObj.year - minDateObj.year);
        this.wheels[1].translateY = this.getDistanceByIndex(dateObj.month - 1);
        this.wheels[2].translateY = this.getDistanceByIndex(dateObj.day - 1);
      },
      descBulan: function (blnNum) {
        let returns = '';
        if (blnNum == '01' || blnNum == 1) {
          returns = this.$t('common.months.january')
        } else if (blnNum == '02' || blnNum == 2) {
          returns = this.$t('common.months.february')
        } else if (blnNum == '03' || blnNum == 3) {
          returns = this.$t('common.months.march')
        } else if (blnNum == '04' || blnNum == 4) {
          returns = this.$t('common.months.april')
        } else if (blnNum == '05' || blnNum == 5) {
          returns = this.$t('common.months.may')
        } else if (blnNum == '06' || blnNum == 6) {
          returns = this.$t('common.months.june')
        } else if (blnNum == '07' || blnNum == 7) {
          returns = this.$t('common.months.july')
        } else if (blnNum == '08' || blnNum == 8) {
          returns = this.$t('common.months.august')
        } else if (blnNum == '09' || blnNum == 9) {
          returns = this.$t('common.months.september')
        } else if (blnNum == 10) {
          returns = this.$t('common.months.october')
        } else if (blnNum == 11) {
          returns = this.$t('common.months.november')
        } else if (blnNum == 12) {
          returns = this.$t('common.months.december')
        }
        return returns
      },
      callBulan: function (status, numbers) {
        let returns = '';
        if (status == 1) {
          returns = this.descBulan(numbers);
        }
        return returns
      },
      getDateStrObj: function (dateString, offsetYear, offsetMonth, offsetDay) {
        var tempArr = dateString.split('-');
        return {
          year: ~~tempArr[0],
          month: ~~tempArr[1],
          day: ~~tempArr[2]
        }
      },
      addPrefix: function (num) {
        return num < 10 ? '0' + num : num;
      },
      getDateStr: function (dateObj, offsetYear, offsetMonth, offsetDay) {
        var tempArr = [];
        tempArr.push(dateObj.getFullYear() + (offsetYear || 0));
        tempArr.push(this.addPrefix(dateObj.getMonth() + 1 + (offsetMonth || 0)));
        tempArr.push(this.addPrefix(dateObj.getDate() + (offsetDay || 0)));
        return tempArr.join('-'); 
      },
      checkIsFormatStr: function (dateString) {
        if (dateString && typeof (dateString) == 'string') {
          var tempArr = dateString.split('-');
          if (tempArr.length > 2) {
            var year = ~~tempArr[0],
              month = ~~tempArr[1],
              day = ~~tempArr[2];
            if ((year > 0 && year < 10000) && (month >= 1 && month <= 12) && (day >= 1 && day <= this.calcDays(year, month))) {
              return true;
            }
          }
        }
        return false;
      },
      getDistanceByIndex: function (index) {
        return (2 - index) * this.liHeight;
      },
      getIndexByDistance: function (translateY) {
        return parseInt(-translateY / this.liHeight) + 2;
      },
      getWheelData: function (wheelIndex) {
        var dataIndex = this.getIndexByDistance(this.wheels[wheelIndex].translateY);
        dataIndex = dataIndex < 0 ? 0 : dataIndex;
        dataIndex = dataIndex >= this.wheels[wheelIndex].data.length ? this.wheels[wheelIndex].data.length - 1 : dataIndex;

        clearTimeout(this.timerId);
        this.timerId = setTimeout(() => {
          if (this.activeInput == 'from') {
            this.getSelectData()
          } else {
            this.getSelectData2()
          }
        }, 500)

        return this.wheels[wheelIndex].data[dataIndex];
      },
      calcDays: function (year, month) {
        return new Date(year, month, 0).getDate();
      },
      fixPosition: function (distance) {
        return Math.round(distance / this.liHeight) * this.liHeight;
      },
      checkIsOverBorder: function (curWheelObj) {
        var _this = this;
        this.oversizeBorder = -(curWheelObj.data.length - 3) * this.liHeight;
        if (curWheelObj.translateY > 2 * this.liHeight) {
          setTimeout(function () {
            curWheelObj.transitionTime = '700ms';
            curWheelObj.translateY = 2 * _this.liHeight;
          }, 100);
        } else if (curWheelObj.translateY < this.oversizeBorder) {
          setTimeout(function () {
            curWheelObj.transitionTime = '700ms';
            curWheelObj.translateY = _this.oversizeBorder;
          }, 100);
        }
      },
      updateDays: function () {
        var newMonthDaysNum = this.calcDays(this.getWheelData(0), this.getWheelData(1));
        if (newMonthDaysNum > 0 && this.wheels[2].data.length != newMonthDaysNum) {
          var tempArr = [];
          for (var k = 1; k <= newMonthDaysNum; k++) {
            tempArr.push(k);
          }
          this.wheels[2].data = tempArr;
          this.checkIsOverBorder(this.wheels[2]);
        }
      },
      handleTouch: function (e, index) {
        e = e || window.event;
        var curWheelObj = typeof (index) == 'number' ? this.wheels[index] : this.wheels[this.activeWheelIndex];
        switch (e.type) {
          case 'touchstart':
          case 'mousedown':
            if (e.type == 'touchstart') {
              this.startY = e.touches[0].clientY;
            } else {
              this.startY = e.clientY;
              this.activeWheelIndex = index;
              this.clickFlag = true;
              e.preventDefault();
            }
            curWheelObj.anim = false;
            this.oldMoveY = this.startY;
            this.startTime = (new Date()).getTime();
            break;

          case 'touchend':
          case 'mouseup':
            if (e.type == 'touchend') {
              this.moveEndY = e.changedTouches[0].clientY;
            } else {
              this.moveEndY = e.clientY;
              this.clickFlag = false;
            }

            this.offsetDistance = this.moveEndY - this.startY;
            curWheelObj.anim = true;
            curWheelObj.translateY = this.fixPosition(curWheelObj.translateY + this.offset);
            var offsetTime = (new Date()).getTime() - this.startTime;
            var scrollSpeed = this.offsetDistance / offsetTime;
            var tempTime = Math.abs(parseInt(scrollSpeed * 1000));
            curWheelObj.transitionTime = '700ms';
            if (Math.abs(scrollSpeed) > 0.3) {
              curWheelObj.transitionTime = tempTime > 700 ? (tempTime + 'ms') : '700ms';
              curWheelObj.translateY = this.fixPosition(curWheelObj.translateY + scrollSpeed * 250);
            }
            this.checkIsOverBorder(curWheelObj);
            this.clearHover();
            break;

          case 'mousemove':
          case 'touchmove':
            e.preventDefault();
            if (e.type == 'mousemove' && !this.clickFlag) {
              return false;
            }
            this.moveY = e.type == 'touchmove' ? e.touches[0].clientY : e.clientY;
            this.offset = this.moveY - this.oldMoveY;
            curWheelObj.translateY += this.offset;
            this.oldMoveY = this.moveY;
            break;

          case 'mousewheel':
            curWheelObj.anim = true;
            curWheelObj.translateY = this.fixPosition(curWheelObj.translateY + parseInt((e.wheelDelta || e.detail) * 0.3));
            this.oversizeBorder = -(curWheelObj.data.length - 3) * this.liHeight;
            this.checkIsOverBorder(curWheelObj);
            break;
        }
        if (index <= 2) {
          this.updateDays();
        }
      },
      handleSingleClick: function (e, wheelIndex, itemIndex) {
        if (Math.abs(this.offsetDistance) < 30) {
          this.wheels[wheelIndex].translateY = this.getDistanceByIndex(itemIndex);
        }
      },
      hoverClass: function (e, wheelIndex, itemIndex) {
        this.activeClick.wheelIndex = wheelIndex;
        this.activeClick.itemIndex = itemIndex;
      },
      clearHover: function () {
        this.activeClick.wheelIndex = -100;
        this.activeClick.itemIndex = -100;
      },
      getSelectData: function () {
        var _this = this;
        var tempArr = [];
        this.wheels.forEach(function (item, wheelIndex) {
          tempArr.push(_this.addPrefix(_this.getWheelData(wheelIndex)));
        });
        this.selectValue = tempArr.join('-');
        var dates = this.selectValue.split('-');
        this.selectNilai = dates[0] + '-' + dates[1] + '-' + dates[2];

        var dateObjFrom = this.getDateStrObj(this.selectValue);
        var minDateObj = this.getDateStrObj(this.minDate);
        var maxDateObj = this.getDateStrObj(this.maxDate);

        if (dateObjFrom.year == minDateObj.year) {
          if (dateObjFrom.month < minDateObj.month) {
            this.wheels[1].translateY = this.getDistanceByIndex(minDateObj.month -1);
          }
          if (dateObjFrom.month == minDateObj.month) {
            if (dateObjFrom.day < minDateObj.day) {
              this.wheels[2].translateY = this.getDistanceByIndex(minDateObj.day - 1);
            }
          }
        }
        if (dateObjFrom.year == maxDateObj.year) {
          if (dateObjFrom.month > maxDateObj.month) {
            this.wheels[1].translateY = this.getDistanceByIndex(maxDateObj.month - 1);
          }
          if (dateObjFrom.month == maxDateObj.month) {
            if (dateObjFrom.day > maxDateObj.day) {
              this.wheels[2].translateY = this.getDistanceByIndex(maxDateObj.day - 1);
            }
          }
        }

        if (this.selectValue2) {
          setTimeout(()=>{
            var dateObjTo = this.getDateStrObj(this.selectValue2);

            if (dateObjFrom.year > dateObjTo.year) {
              this.selectValue2 = this.selectValue;
              this.selectNilai2 = this.selectNilai;
            }
            if (dateObjFrom.month > dateObjTo.month) {
              if (dateObjFrom.year == dateObjTo.year) {
                this.selectValue2 = this.selectValue;
                this.selectNilai2 = this.selectNilai;
              }
            }
            if (dateObjFrom.day > dateObjTo.day) {
              if (dateObjFrom.year == dateObjTo.year) {
                if (dateObjFrom.month == dateObjTo.month) {
                  this.selectValue2 = this.selectValue;
                  this.selectNilai2 = this.selectNilai;
                }
              }
            }
          },500)
        }

        this.activePreset = null
        this.$emit('input', this.selectValue);
        this.checkIsNamedPeriod()
      },
      getSelectData2: function () {
        var _this = this;
        var tempArr = [];
        this.wheels.forEach(function (item, wheelIndex) {
          tempArr.push(_this.addPrefix(_this.getWheelData(wheelIndex)));
        });
        this.selectValue2 = tempArr.join('-');
        var dates = this.selectValue2.split('-');
        this.selectNilai2 = dates[0] + '-' + dates[1] + '-' + dates[2];

        var dateObjTo = this.getDateStrObj(this.selectValue2);
        var minDateObj = this.getDateStrObj(this.minDate);
        var maxDateObj = this.getDateStrObj(this.maxDate);

        if (dateObjTo.year == minDateObj.year) {
          if (dateObjTo.month < minDateObj.month) {
            this.wheels[1].translateY = this.getDistanceByIndex(minDateObj.month -1);
          }
          if (dateObjTo.month == minDateObj.month) {
            if (dateObjTo.day < minDateObj.day) {
              this.wheels[2].translateY = this.getDistanceByIndex(minDateObj.day - 1);
            }
          }
        }
        if (dateObjTo.year == maxDateObj.year) {
          if (dateObjTo.month > maxDateObj.month) {
            this.wheels[1].translateY = this.getDistanceByIndex(maxDateObj.month - 1);
          }
          if (dateObjTo.month == maxDateObj.month) {
            if (dateObjTo.day > maxDateObj.day) {
              this.wheels[2].translateY = this.getDistanceByIndex(maxDateObj.day - 1);
            }
          }
        }

        if (this.selectValue) {
          var dateObjFrom = this.getDateStrObj(this.selectValue);
          if (dateObjFrom.year > dateObjTo.year) {
            this.wheels[0].translateY = this.getDistanceByIndex(dateObjFrom.year - minDateObj.year);
          }
          if (dateObjFrom.month > dateObjTo.month) {
            if (dateObjFrom.year == dateObjTo.year) {
              this.wheels[1].translateY = this.getDistanceByIndex(dateObjFrom.month - 1);
            }
          }
          if (dateObjFrom.day > dateObjTo.day) {
            if (dateObjFrom.year == dateObjTo.year) {
              if (dateObjFrom.month == dateObjTo.month) {
                this.wheels[2].translateY = this.getDistanceByIndex(dateObjFrom.day - 1);
              }
            }
          }
        }

        this.activePreset = null
        this.$emit('input2', this.selectValue2);
        this.checkIsNamedPeriod()
      },
      hidePanel: function () {
        this.clearHover();
        this.popShow = false;
        if (this.selectValue) {
          this.locateWheelByVal(this.selectValue);
        }
      },
      hidePanel2: function () {
        this.clearHover();
        this.popShow = false;
        if (this.selectValue2) {
          this.locateWheelByVal(this.selectValue2);
        }
      },
      showPanel: function () {
        this.clearHover();
        this.activeInput = "from"
        this.popShow = true;
        if (this.selectValue) {
          this.locateWheelByVal(this.selectValue)
        }
      },
      showPanel2: function () {
        this.clearHover();
        this.activeInput = "to"
        this.popShow = true;
        if (this.selectValue2) {
          this.locateWheelByVal(this.selectValue2)
        }
      },
    },
  }
</script>
